export const getCurrentPageRows = (gridApi) => {
  const rows = [];

  if (!gridApi?.forEachNodeAfterFilterAndSort) return rows;

  const pageSize = gridApi.paginationGetPageSize?.() ?? 0;
  const currentPage = gridApi.paginationGetCurrentPage?.() ?? 0;
  const isGridPaginated = pageSize > 0 && gridApi.paginationGetTotalPages?.() > 1;

  const start = currentPage * pageSize;
  const end = start + pageSize;

  gridApi.forEachNodeAfterFilterAndSort((node, index) => {
    if (!node?.data) return;
    if (isGridPaginated && (index < start || index >= end)) return;

    rows.push(node.data);
  });

  return rows;
};
